import { renderToString } from 'react-dom/server';
import iconDefinition, {
  IconDefinitionProps,
  IconDefinitionKeys,
} from './AhmIcon.types';
import './AhmIcon.scss';
import React from 'react';

type IconProps = {
  iconName: IconDefinitionKeys;
  color?: string;
  renderType?: 'image' | 'svg';
  classes?: string;
};

const iconPlaceholder = {
  viewBoxHeight: 0,
  viewBoxWidth: 0,
  paths: [],
} as IconDefinitionProps;

const AhmIcon = ({
  iconName,
  color,
  classes,
  renderType,
}: IconProps): JSX.Element => {
  const themeValue = 'Acura';
  const brandIconName =
    `${iconName}${themeValue}` as keyof typeof iconDefinition;
  const iconData = iconDefinition[brandIconName] || iconPlaceholder;

  if (!iconData || !iconName) {
    return <></>;
  }
  const { viewBoxWidth, viewBoxHeight, paths } = iconData;
  const iconSvgElement = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      className={`ahm-icon ${classes}`}
      style={{ color: color || '' }}
      data-name={brandIconName}
    >
      {paths.map(
        (
          {
            strokeLinejoin,
            strokeLinecap,
            strokeMiterlimit,
            strokeWidth,
            haveFill,
            d,
          },
          index
        ) => (
          <path
            key={`${iconName}${index}`}
            className="test"
            strokeLinejoin={strokeLinejoin}
            strokeLinecap={strokeLinecap}
            strokeMiterlimit={strokeMiterlimit}
            strokeWidth={strokeWidth}
            stroke={strokeWidth ? 'currentColor' : 'none'}
            fill={strokeWidth && !haveFill ? 'none' : 'currentColor'}
            d={d}
          ></path>
        )
      )}
    </svg>
  );

  if (renderType === 'image') {
    return (
      <img
        className={classes}
        alt="icon"
        src={
          'data:image/svg+xml;utf8,' +
          encodeURIComponent(renderToString(iconSvgElement))
        }
      />
    );
  } else {
    return iconSvgElement;
  }
};

export default AhmIcon;
